import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";

/**
 * Service for managing campaign exclusion list assignments.
 * F-022: Member Exclusion Lists - CRUD operations for list-campaign associations.
 */
@Injectable({
    providedIn: 'root'
})
export class CampaignExclusionListAssignmentService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/campaignExclusionListAssignments')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-link-slash';
    }
}
